export const styles = {
	label: 'pl-1 text-lg md:text-[0.85rem] font-light text-gray-500 flex mb-0.5',
	radioLabel: 'text-sm font-light',
	smallInput:
		'w-40 min-h-12 md:min-h-9 rounded-md border border-gray-400 px-2 py-1 text-gray-600 focus:outline-none active:outline-none transition-all duration-300 ease-in-out placeholder:text-sm placeholder:text-gray-600',
	mediumInput:
		'w-full min-h-12 md:min-h-9 md:w-60 rounded-md border border-gray-400 px-2 py-1 text-gray-600 focus:outline-none active:outline-none transition-all duration-300 ease-in-out placeholder:text-sm placeholder:text-gray-600',
	largeInput:
		'w-full min-h-12 md:min-h-9 rounded-md border border-gray-400 px-2 py-1 text-gray-600 focus:outline-none active:outline-none transition-all duration-300 ease-in-out placeholder:text-sm placeholder:text-gray-600',
	error: 'border-red-500 placeholder:text-red-500',
	textArea:
		'w-full min-h-40 rounded-md border border-gray-400 px-2 py-1 text-gray-600 focus:outline-none active:outline-none transition-all duration-300 ease-in-out placeholder:text-sm placeholder:text-gray-600',
	pageHeader: 'text-3xl font-semibold text-gray-500',
};
